import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoGrup } from '../FikoGrup';
import { FikoImporter } from '../FikoImporter';
import { FikoImporterAPTCAT } from '../FikoImporter.APTCAT';
import { FikoSahne } from '../FikoSahne';
import { FikoAktivitePuntalama } from './Aktiviteler/dialog-fiko-puntalama/FikoPuntalama';
import { FikoApt } from './FikoApt';
import { FikoAPTCAT } from './FikoAPTCAD';
import { Fikogram } from './Fikogram';

export class Fikogramlar extends FikoGrup {
    override type: any = "Fikogramlar";
    /** */
    sayac = 1;
    /** */
    loader: THREE.FileLoader = new THREE.FileLoader();

    public override get liste(): Fikogram[] {
        return this.children as Fikogram[];
    }

    sagButonlar = [
        {
            isim: "Operasyon Ekle",
            simge: "plus",
            tiklandi: () => {
                this.ekleFikogram();
            }
        },
        {
            isim: "Dosyadan Ekle",
            simge: "upload",
            tiklandi: () => {
                this.ekleDosyadan();
            }
        },
    ];

    // sagMenu: any[] = []

    aracCubugu: any[] = []

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/id-cards.webp";

    }


    ekleFikogram(isim?: string) {
        this.ekle(new Fikogram(this.sahne, isim ? isim : 'Fikogram.' + this.sayac));
        this.sayac += 1;
    }

    ekleDosyadan(filter?: string) {
        const importer = new FikoImporter(this);
        importer.dosyadan(".FikoApt, .FikoAptv1, .apt, .aptsource").then((_rslt: any) => {
            this.ekle(_rslt)
        })

        // var _this = this;
        // let input = document.createElement("input");
        // input.type = "file";
        // input.multiple = true;
        // input.accept = ".FikoApt, .FikoAptv1, .apt, .aptsource"
        // var _tempDosyalar: any;
        // input.onchange = async ($event: any) => {
        //     if (!_tempDosyalar) {
        //         _tempDosyalar = $event.target.files
        //     }
        //     if (_tempDosyalar && _tempDosyalar[0]) {
        //         for (let i = 0; i < _tempDosyalar.length; i++) {
        //             const dosya = _tempDosyalar[i];
        //             // const dosya: File = $event.target.files[0]
        //             const sahip = new Fikogram(_this.sahne);
        //             await _this.ekleApt(dosya, sahip);
        //         }
        //     }
        // }
        // input.click();
    }
    async ekleApt(dosya: any, sahip: any) {
        var _this = this;

        return new Promise((resolve: any, reject) => {

            const importer = new FikoImporterAPTCAT(sahip.sahne);
            importer.alDosyadan(dosya).then((_rslt: any) => {
                const apt = new FikoAPTCAT(this.sahne, dosya.name.replace(".FikoApt", "").replace(".AptSource", "").replace(".aptsource", ""));

                apt.tarihi = _rslt.tarihi;
                apt.programIsmi = _rslt.programIsmi;
                apt.kureMerkezi = _rslt.kureMerkezi;
                apt.operasyonIsmi = _rslt.operasyonIsmi;
                apt.eksenKoord = _rslt.eksenKoord;
                apt.aktiviteler = _rslt.aktiviteler;
                apt.eksen = _rslt.eksen;
                apt.takimYolu = _rslt.takimYolu;

                apt.ekle(_rslt.takimYolu)

                sahip.name = _rslt.programIsmi;

                sahip.ekle(apt);

                _this.ekle(sahip);

                sahip.sahne.anaGosterim.FikoYT.degisti.emit();
                sahip.sahne.anaGosterim.ciz();
                resolve();
            });
            /*
                        this.loader.load(URL.createObjectURL(dosya),(data: any) => {
                                let fikoApt = new FikoApt(this.sahne);
            
                                fikoApt.arrayApt = data.split("\n");
                                fikoApt.parcala();
                                fikoApt.agactaGorunur = true;
                                fikoApt.name = fikoApt.name.replace(".FikoAPT", "");
            
                                sahip.name = fikoApt.name;
            
                                sahip.ekle(fikoApt);
            
                                _this.ekle(sahip);
            
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                resolve();
                            },
                            // function (xhr) {
                            //     console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                            // },
                            // function (err) {
                            //     console.error(err);
                            // }
                        );*/

        });
    }


    tiklandi() {
    }

    ciftTiklandi() {
    }

    sagTiklandi() {
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

        _rslt.children = []
        for (let i = 0; i < this.children.length; i++) {
            const element = this.children[i];
            _rslt.children.push(element.toJSON());
        }

        _rslt.userData = this._serializeUserData();
        _rslt.visible = this.visible;

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new Fikogramlar(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        for (let i = 0; i < json.children.length; i++) {
            let element = json.children[i];
            _rslt.ekle(jsondan(sahne, _rslt, element));
        }

        if (json.userData) _rslt._restoreUserData(json.userData);
        if (json.visible !== undefined) _rslt.visible = json.visible;

        return _rslt;
    }
}